import React from 'react';

const CameraSubmission = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <main className="content">
          <div className="card-box">
            <div className="page-header">
              <h1>Camera Submission</h1>
            </div>
            <section>
              <h3>Revision and Camera-Ready Submission Process</h3>
              <p>
                If your paper is accepted, you will receive instructions through CMT about the revision and camera-ready submission process.
                Follow the portal's guidelines carefully and upload the final version by the camera-ready deadline.
              </p>
              <p>
                Ensure the camera-ready paper includes author names, affiliations, and any required copyright forms or IEEE metadata as instructed.
              </p>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CameraSubmission;
